
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'
import Config from '@/utils/config'
import Link from '@/components/Link.vue'

const list = {
  cover_board_1: {
    type: 'link',
    link: 'https://m.thecover.cn/subject.html?id=10330&channel_type=30',
    label: 'subject',
    param: {
      id: 10330,
    },
  },
  cover_board_2: {
    type: 'video',
    link: 'https://imgcdn.thecover.cn/fcapp_d32bee0d-4b38-4489-a4b8-ea6bf050b204_1677986715383.mp4',
    poster: 'https://imgcdn.thecover.cn/2023-03-05/jobsystem/1z213a2b1t1f3b2h321x2y2y2a382p2b212w32202y1k321l1u3e1w3d2f1v2v372e2y283737392s3a1l341f22213a1k251t2s2a301z2e1v1b1l2f392b2s2q173c2z1e2z35361f1w312v2w291k262h1j262q39302u1z2v1p1p.jpg',
  },
  cover_board_3: {
    type: 'link',
    link: 'https://m.thecover.cn/news_details.html?eid=x7gXeffMGIGH90qSdq8Jkw==&channelId=null',
    label: 'news',
    param: {
      id: 10352156
    },
  },
  cover_board_4: {
    type: 'link',
    link: 'http://h5.thecover.cn/c/jdpm/jtdi/index.html',
  },
  cover_board_5: {
    type: 'video',
    link: 'https://imgcdn.thecover.cn/fcapp_a9cceed1-1de1-4490-ad89-d855e9c75733_1677686148936.mp4',
    poster: 'https://imgcdn.thecover.cn/2023-03-02/jobsystem/1z213a2b1t1f3b2h321x2y2v2c1h242i2e2b2h1y3e2i1y262h1j1j2q212v2d1t3a2d292x1k1c2e2u231k2c271f1u341g3432323c261k301e30352w3b1h1j2q3331353b36252i1g1u2u1v3333243a1f2t2t3e2b2e172v1p1p.jpg',
  },
  cover_board_6: {
    type: 'video',
    link: 'https://yunyingcdn.thecover.cn/o_1gqtui0oe474rq1segv0413629.mp4',
    poster: 'https://imgcdn.thecover.cn/2023-03-04/jobsystem/1z213a2b1t1f3b2h321x2v22311t2g3a352s2725391i1k301v1e1f2x2q17312734281f2v211w3a202b2b3a2r2t1j1w352e1v1k221i2t1v2w3c1d2h2h172r201l213b2a2f2b1k1e3b2s1u2h2g231d232r1h2y2t2831291p1p.jpg'
  },
  cover_board_7: {
    type: 'link',
    link: 'https://m.thecover.cn/subject_detail.html?subjid=10330&cateid=8081',
    label: 'renda',
    param: {
      id: 10330,
      type: 8081,
    },
  },
  cover_board_8: {
    type: 'link',
    link: 'https://m.thecover.cn/live_casting.html?eid=40eJpjPh2MaH90qSdq8Jkw==&version=new&channelId=null',
    label: 'live'
  },
};
let gameUnityInstance, pgInt;
@Options({
  data() {
    return {
      pg: 0,
      show: '',
      isWin: false,
      isTip: false,
      isBlur: false,
    }
  },
  computed: {
    ...mapState(['userInfo', 'shareData', 'activityData'])
  },
  components: {
    Link,
  },
  created() {
    // @ts-ignore
    window.UnityReceive = (val) => {
      if (val) {
        const info = list[val];

        if (COVERAPP.Attribute.isApp()) {
          if (info.label === 'subject') {
            window.location.href = `${Config.APP_SCHEME_URL}/news?id=${ info.param.id }&flag=30`;
            return;
          }

          if (info.label === 'news') {
            window.location.href = `${Config.APP_SCHEME_URL}/news?id=${ info.param.id }&flag=1`
            return;
          }

          if (info.label === 'renda') {
            window.location.href = `${Config.APP_SCHEME_URL}/news?id=0&flag=204&subjectid=10330&catename=人大代表在这里&cateid=8081`;
            return;
          }

          if (info.label === 'live') {
            window.location.href = `${Config.APP_SCHEME_URL}/news?id=10346693&flag=24`;
            return;
          }
        }
        
        this.show = info;

        if (info.type === 'video') {
          this.$nextTick(() => {
            this.$refs.video.play();
            // @ts-ignore
            document.getElementById('video').play();
          });
        }
      }
    }

    window.onblur = () => {
      this.isBlur = true;
    }
  },
  mounted () {
    this.$common.pageLoaded()
    let homeShareData = JSON.parse(JSON.stringify(this.shareData))
    homeShareData.link = window.location.href
    this.$common.onshare(homeShareData)
    this.$common.track('load', '进入首页')
    if (COVERAPP.Attribute.isApp() || COVERAPP.Attribute.isIOS() || COVERAPP.Attribute.isAndroid()) {
      this.init();
    } else {
      this.isWin = true;
    }
  },
  methods: {
    init() {
      const _this = this;
      let domain = `https://yunyingcdn.thecover.cn/thecovermetaone/2303081/`;
      // let domain = ``;
      // @ts-ignore
      createUnityInstance(document.querySelector("#meta"), {
        dataUrl: domain + "Build/build.data.unityweb",
        frameworkUrl: domain + "Build/build.framework.js.unityweb",
        codeUrl: domain + "Build/build.wasm.unityweb",
        streamingAssetsUrl: "StreamingAssets",
        companyName: "DefaultCompany",
        productName: "lh",
        productVersion: "0.1",
        // matchWebGLToCanvasSize: false, // Uncomment this to separately control WebGL canvas render size and DOM element size.
        devicePixelRatio: 1.5, // Uncomment this to override low DPI rendering on high DPI displays.
      }, function(progress) {
        if (progress >= 1) {
          _this.pg = 99;
          const isTip = localStorage.getItem('2023lianghui_tip') || false;
          _this.isTip = isTip ? false : true;
          setTimeout(() => {
            localStorage.setItem('2023lianghui_tip', 'true');
            if (!isTip) {
              setTimeout(() => {
                _this.isTip = false;
              }, 10000);
            }
            _this.pg = 100;
          }, 3000);
          return;
        }
        const pg = Math.floor(progress * 100);
        if (pg === 90) {
          _this.fakePg();
        }
        _this.pg = pg;
      }).then(res => {
        gameUnityInstance = res;
      })
    },
    handleBlur() {
      this.isBlur = false;
    },
    fakePg() {
      const _this = this;
      clearInterval(pgInt);
      pgInt = setInterval(() => {
        let pg = _this.pg;
        if (pg >= 99) {
          clearInterval(pgInt);
          return;
        }
        if (pg >= 90 && pg < 98) {
          pg++;
          _this.pg = pg;
        }
      }, 1000);
    },
    onVideo() {
      this.$refs.video.play();
      // @ts-ignore
      document.getElementById('video').play();
    },
  },
})
export default class Home extends Vue {}
